// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1___95772e2a22cd12a5f48","cls2":"SuggestionReason-cls2___4f44f60f53920b0507d SuggestionReason-cls1___95772e2a22cd12a5f48"};